exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.review-picker[data-v-7a9ef760]{border:1px solid #d5dde2;display:grid;grid-template-columns:1fr 1fr\n}\n.review-picker__wrapper[data-v-7a9ef760]{grid-column:1/-1;margin:0 0 30px\n}\n.review-picker label[data-v-7a9ef760]{font-weight:400\n}\n.review-picker__list[data-v-7a9ef760]{height:350px;overflow:scroll;padding:20px\n}\n.review-picker__list input[data-v-7a9ef760]{display:none\n}\n.review-picker__list input:checked+label[data-v-7a9ef760]{opacity:.5;pointer-events:none\n}\n.review-picker__selected[data-v-7a9ef760]{border-left:1px solid #d5dde2\n}", ""]);

// exports
